(function () {
  let testimonialsSlider = () => {
    $(".testimonials-section").each(function () {
      if ($(this).hasClass("slider_started")) {
        return "";
      }

      $(this).addClass("slider_started");
      let id = $(this).attr("id");
      let section = $(this);
      let counterCurrent = section.find(".testimonials__counter-current");
      let counterTotal = section.find(".testimonials__counter-total");
      let totalSlides = section.find(".testimonials__slide").length;

      // Calculate slides per view based on screen size
      let getSlidesPerView = () => {
        if (window.innerWidth >= 990) {
          return 3;
        } else if (window.innerWidth >= 750) {
          return 2;
        }
        return 1;
      };

      // Calculate total pages based on slides per view
      let getTotalPages = () => {
        let slidesPerView = getSlidesPerView();
        return Math.max(1, totalSlides - slidesPerView + 1);
      };

      // Update counter and navigation buttons
      let updateCounter = (swiper) => {
        if (!swiper) return;

        let activeIndex = swiper.activeIndex;
        let slidesPerView = getSlidesPerView();
        // Show the first visible testimonial number (1-based)
        let currentPage = activeIndex + 1;
        let totalPages = getTotalPages();

        if (counterCurrent.length) {
          counterCurrent.text(currentPage);
        }
        if (counterTotal.length) {
          counterTotal.text(totalPages);
        }
      };

      // Initialize Swiper
      let swiperParams = {
        slidesPerView: 1,
        spaceBetween: 24,
        watchSlidesProgress: true,
        updateOnWindowResize: true,
        allowTouchMove: true,
        slidesPerGroup: 1,
        breakpoints: {
          750: {
            slidesPerView: 2,
            spaceBetween: 24,
            slidesPerGroup: 1,
          },
          990: {
            slidesPerView: 3,
            spaceBetween: 36,
            slidesPerGroup: 1,
          },
        },
        on: {
          init: function (swiper) {
            updateCounter(swiper);
          },
          slideChange: function (swiper) {
            updateCounter(swiper);
          },
          resize: function (swiper) {
            updateCounter(swiper);
          },
        },
      };

      // Add navigation
      swiperParams.navigation = {
        nextEl: `#${id} .swiper-button-next__testimonials`,
        prevEl: `#${id} .swiper-button-prev__testimonials`,
      };

      let swiper = new Swiper(`#${id} .testimonials__slider`, swiperParams);
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    testimonialsSlider();
  });

  document.addEventListener("shopify:section:load", function () {
    testimonialsSlider();
  });

  document.addEventListener("shopify:section:reorder", function () {
    testimonialsSlider();
  });

  // Initialize on page load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", testimonialsSlider);
  } else {
    testimonialsSlider();
  }
})();
